import ReportFiltersProvider, { ReportFiltersProviderProps } from './ReportFiltersProvider';

export type ReportFiltersProps<TGroupBy> = ReportFiltersProviderProps<TGroupBy>;

const ReportFilters = <TGroupBy,>({ children, ...others }: ReportFiltersProps<TGroupBy>) => (
  <ReportFiltersProvider {...others}>{children}</ReportFiltersProvider>
);

export default ReportFilters;
